// extracted by mini-css-extract-plugin
export default {"container":"CardContainer_container__2CJfD","card-container":"CardContainer_card-container__hWzs4","logo":"CardContainer_logo__NpcDb"};